module.exports = __webpack_public_path__ + "img/web-required.5d9ed635.svg";